import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";

export const equipmentCertificateSchema = yup.object({
  certificateNo: yup.string().required(REQUIRED_MESSAGE),
  stickerNo: yup.string().required(REQUIRED_MESSAGE),
  equipmentDescription: yup.string().required(REQUIRED_MESSAGE),
  equipmentSerialIdNo: yup.string().required(REQUIRED_MESSAGE),
  equipmentType: yup.string().required(REQUIRED_MESSAGE),

  inspectionDate: yup.string().required(REQUIRED_MESSAGE),
  expiryDate: yup.string().required(REQUIRED_MESSAGE),

  companyName: yup.string().required(REQUIRED_MESSAGE),
  plateNo: yup.string().required(REQUIRED_MESSAGE),
  manufacturer: yup.string().required(REQUIRED_MESSAGE),

  inspectedBy: yup.string().required(REQUIRED_MESSAGE),
  capacitySWL: yup.string().required(REQUIRED_MESSAGE),
});